export default "__VITE_ASSET__BmHoO8eq__"